/** @jsx jsx */

import { Component } from "react";
import { css, jsx } from "@emotion/react";
import SocialReviewCard from "./SocialReviewCard";
const POST_LIMIT = 40;
const PRODUCTS = [
    "noissueTissue",
    "noissueStamps",
    "noissueSticker",
    "noissueCards",
    "noissueTape",
    "noissueMailers",
];

export default class SocialReviewSection extends Component {
    constructor(props) {
        super(props);
        const { posts } = this.props;
        this.state = {
            showPosts: 40,
            postsLength: posts.length,
            activeFilter: "",
        };
    }

    loadMore(postCount) {
        this.setState({ showPosts: postCount });
    }

    resetFilters() {
        this.setState({ activeFilter: "" });
    }

    setFilter(filter) {
        this.setState({ activeFilter: filter });
    }

    setPostLength(length) {
        this.setState({ postsLength: length });
    }

    getProductTag() {
        const { productsData } = this.props;
        const product = [];
        productsData.forEach((val) => {
            val.wildSectionTagSlug && product.push(val.wildSectionTagSlug.replace(/hash-/i, '#'));
        });
        return product;
    }

    getProductName(product) {
        /* const { productsData } = this.props;
        productsData.forEach((val) => {
            if (val.wildSectionTagSlug && val.wildSectionTagSlug.includes(product)){
                product = val.displayName;
            }
        }); */
        if (product === "noissueTissue") {
            return "noissue Tissue";
        }
        if (product === "noissueSticker") {
            return "noissue Stickers";
        }
        if (product === "noissueTape") {
            return "noissue Tape";
        }
        if (product === "noissueMailers") {
            return "noissue Mailers";
        }
        if (product === "noissueStamps") {
            return "noissue Stamps";
        }
        if (product === "noissueCards") {
            return "noissue Cards";
        }
        if (product === "noissueFoodsafe") {
            return "noissue Food Safe";
        }
        if (product === "noissueToteBags") {
            return "noissue Tote Bags";
        }
        if (product === "noissueKraftMailers") {
            return "noissue Kraft Mailers";
        }
        return product;
    }

    render() {
        const { posts } = this.props;
        const { showPosts, activeFilter } = this.state;

        const finalPosts =
            posts &&
            posts.filter((post) => {
                if (
                    post.node &&
                    post.node.title &&
                    post.node.title.charAt(0) === "@" &&
                    post.node.feature_image
                ) {
                    if (activeFilter && post.node.tags) {
                        let t = post.node.tags.find((tag) => {
                            if (tag.name && tag.name.charAt(0) === "#")
                                return (
                                    activeFilter.toLowerCase() ===
                                    tag.name.substr(1).toLowerCase()
                                );
                            else if (tag.name)
                                return (
                                    activeFilter.toLowerCase() ===
                                    tag.name.substr(1).toLowerCase()
                                );

                            return false;
                        });
                        if (t) {
                            return true;
                        }
                    }
                    if (!activeFilter) return true;
                }
                return false;
            });

        return (
            <section
                css={css`
                    margin: 0 auto;
                    padding: 4rem 2rem;
                    background-color: #fff;
                `}
            >
                <h1
                    css={css`
                        padding: 2rem;
                        font-size: 4rem;
                        color: #fd566f;
                        line-height: 4rem;

                        @media (max-width: 768px) {
                            font-size: 3rem;
                            line-height: 3rem;
                        }
                    `}
                >
                    Social Reviews
                </h1>
                <div
                    css={css`
                        display: flex;
                        min-width: 32rem;
                        margin: auto;
                        overflow: auto;
                        justify-content: center;
                        max-width: 132rem;

                        @media (max-width: 1024px) {
                            justify-content: start;
                        }

                        ::-webkit-scrollbar {
                            width: 0.5rem;
                            height: 1rem;
                            background-color: transparent;
                            border-radius: 0.5rem;
                        }
                        ::-webkit-scrollbar-thumb {
                            box-shadow: inset 0 0 6px #ededed;
                            border-radius: 10px;
                            background-color: #ededed;
                        }
                    `}
                >
                    {PRODUCTS.map((product, index) => (
                        <div
                            key={'pd'+index}
                            css={css`
                                min-width: max-content;
                                height: 5rem;
                                padding: 1rem 2rem;
                                background: ${activeFilter === product
                                    ? "#FD566F"
                                    : "#F2F2F2"};
                                margin: 1rem;
                                border-radius: 5rem;
                                cursor: pointer;
                            `}
                            onClick={() => this.setFilter(product)}
                        >
                            <span
                                css={css`
                                    color: ${activeFilter === product
                                        ? "#FFF"
                                        : "#393972"};
                                    font-size: 1.6rem;
                                    font-weight: 600;
                                `}
                            >
                                {this.getProductName(product)}
                            </span>
                        </div>
                    ))}
                    <div
                        css={css`
                            padding: 2rem;
                            flex: 1;
                            text-align: end;
                            min-width: 12rem;
                            display: block;
                            @media(max-width: 1024px){
                                display: none;
                            }
                        `}
                    >
                        <span
                            css={css`
                                color: #fd566f;
                                font-size: 1.6rem;
                                font-weight: 600;
                                cursor: pointer;
                            `}
                            onClick={() => this.resetFilters()}
                        >
                            Clear All
                        </span>
                    </div>
                </div>
                <div
                        css={css`
                            padding: 2rem;
                            text-align: center;
                            display: none;
                            @media(max-width: 1024px){
                                display: block;
                            }
                        `}
                    >
                        <span
                            css={css`
                                color: #fd566f;
                                font-size: 1.6rem;
                                font-weight: 600;
                                cursor: pointer;
                            `}
                            onClick={() => this.resetFilters()}
                        >
                            Clear All
                        </span>
                    </div>
                <div css={css``}>
                    <div
                        css={css`
                            text-align: center;
                            margin-top: 7rem;
                            margin-bottom: 5rem;
                            max-width: 140rem;
                            margin: auto;
                            padding: 2rem 0;
                            display: grid;
                            justify-content: center;
                            grid-template-columns: repeat(
                                auto-fit,
                                minmax(33rem, max-content)
                            );
                            @media(max-width: 699px){
                                grid-template-columns: repeat(auto-fit, minmax(26rem, max-content));
                            }
                            @media(max-width: 560px){
                                grid-template-columns: repeat(auto-fit, minmax(17rem, max-content));
                            }
                            @media(max-width: 380px){
                                grid-template-columns: repeat(auto-fit, minmax(13rem, max-content));
                            }
                        `}
                    >
                        {finalPosts &&
                            finalPosts
                                .splice(0, showPosts)
                                .map((post, index) => (
                                    <SocialReviewCard
                                        key={"srv" + index}
                                        props={post.node}
                                    />
                                ))}
                    </div>
                    <div css={css`margin: 4rem 0; font-size: 2.5em;`}>
                        {finalPosts.length === 0  && 'No results found'}
                    </div>
                    <div
                        css={css`
                            margin: 4rem 0;
                        `}
                    >
                        {finalPosts.length > showPosts && (
                            <button
                                css={css`
                                    font-size: 1.6rem;
                                    font-weight: 400;
                                    line-height: 1.6;
                                    padding: 0.8rem 3rem;
                                    color: #dc5e72;
                                    border-radius: 1rem;
                                    border: 0.2rem solid #dc5e72;
                                    cursor: pointer;
                                `}
                                onClick={() =>
                                    this.loadMore(showPosts + POST_LIMIT)
                                }
                            >
                                Load More
                            </button>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}
